import { Model } from '@vuex-orm/core';
export class Auth extends Model {
  static get entity() {
    return 'auth';
  }

  static setCurrentUser(val) {
    this.commit((state) => (state.currentUser = val));
  }

  static setSession(val) {
    this.commit((state) => (state.session = val));
  }

  /**
   * Sign out the current user
   * @param {boolean} shouldRedirect - Whether to redirect to Cognito logout endpoint (default: true)
   */
  static signOut(shouldRedirect = true) {
    this.commit(async (state) => {
      if (state.currentUser) {
        if (shouldRedirect) {
          await this.signOutRedirect(); // Redirect to AWS Cognito logout endpoint
        }
        state.currentUser.signOut(); // Clear Cognito cookies/storage
        state.currentUser = null;
      }

      if (state.session) {
        state.session = null;
      }
    });
  }

  /**
   * Redirects to the catalog's GET /logout endpoint, which clears the shared
   * Cognito cookies server-side and ends the Cognito Hosted UI session before
   * redirecting on to the login page.
   */
  static async signOutRedirect() {
    const catalogAppUrl = process.env.VUE_APP_CATALOG_APP_URL;
    window.location.href = new URL('/logout', catalogAppUrl).toString();
  };

  /**
   * Redirects to login page when user is null
   */
  static async redirectToLogin() {
    const loginUrl = process.env.VUE_APP_LOGIN_URL || '/login';
    window.location.href = loginUrl;
  };

  static getCurrentUser() {
    return this.getters('getCurrentUser');
  }

  static getSession() {
    return this.getters('getSession');
  }

  static getAppToken() {
    return this.getters('getAppToken');
  }

  /**
   * Whether the signed-in account has a Google identity linked to it.
   *
   * Read straight from the ID token the app already holds, so a caller can
   * decide on first paint without waiting for a round trip. The server remains
   * the authority on whether a change is allowed.
   */
  static hasLinkedGoogleIdentity() {
    return this.getters('getIdentities').some(
      ({ providerName }) => providerName === 'Google'
    );
  }

  static getRefreshToken() {
    const refreshToken = this.getters('getRefreshToken');
    console.log('[Auth.js] getRefreshToken:', refreshToken);
    return refreshToken;
  }

  static getExpireDateAppToken() {
    return this.getters('getExpireDateAppToken');
  }

  static isTokenExpired() {
    return this.getters('isTokenExpired');
  }

  static isInitialized() {
    return this.getters('getInitialized');
  }

  static isAuthenticated() {
    return this.getters('isAuthenticated');
  }

  static isTokenInvalid() {
    return this.getters('getIsTokenInvalid');
  }

  static initialized() {
    this.commit((state) => (state.initialized = true));
  }

  static markTokenInvalid() {
    this.commit((state) => (state.isTokenInvalid = true));
  }

  static apiConfig = {
    actions: {
      revokeToken(refreshToken) {
        return this.post('auth/revoke', { refreshToken }, { save: false });
      },
      refreshToken(refreshToken) {
        return this.post('auth/refresh', { refreshToken }, { save: false });
      }
    }
  };
}

export default Auth;
